var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingAlt11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3C2 2.44772 2.44772 2 3 2H14C14.5523 2 15 2.44772 15 3V20.5H17.75V18H17C16.4477 18 16 17.5523 16 17V12.5C16 11.1193 17.1193 10 18.5 10C19.8807 10 21 11.1193 21 12.5V17C21 17.5523 20.5523 18 20 18H19.25V20.5H21.25C21.6642 20.5 22 20.8358 22 21.25C22 21.6642 21.6642 22 21.25 22H2.75C2.33579 22 2 21.6642 2 21.25C2 21.2106 2.00304 21.1718 2.00891 21.1341C2.00303 21.0902 2 21.0455 2 21V3ZM5 16.5V20H12V16.5C12 14.567 10.433 13 8.5 13C6.567 13 5 14.567 5 16.5ZM7.5 4H4V6H7.5V4ZM9.5 4V6H13V4H9.5ZM7.5 8H4V10H7.5V8ZM9.5 8V10H13V8H9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingAlt11);
export default __webpack_public_path__ + "static/media/building-alt-11.018f9ab6d6bc5a137b14d337ca4c293d.svg";
export { ForwardRef as ReactComponent };